import React from 'react';
import { clsx } from 'clsx';

/** `locked` is derived, not a `users.status` value — a locked account is still
 *  "active" in the DB, but that is not what support needs to see. */
const StatusPill: React.FC<{ status: string }> = ({ status }) => (
  <span
    className={clsx(
      'inline-flex rounded-full px-2 py-0.5 text-[10.5px] font-semibold capitalize',
      status === 'active' && 'bg-success/15 text-success',
      (status === 'locked' || status === 'suspended') && 'bg-destructive/15 text-destructive',
      status === 'pending_invitation' && 'bg-warn/15 text-warn',
      status === 'inactive' && 'bg-muted text-muted-foreground',
    )}
  >
    {status.replace(/_/g, ' ')}
  </span>
);

export default StatusPill;
